import { render, staticRenderFns } from "./VueSelectTempFaculty.vue?vue&type=template&id=135fb320&scoped=true&"
import script from "./VueSelectTempFaculty.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempFaculty.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempFaculty.vue?vue&type=style&index=0&id=135fb320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fb320",
  null
  
)

export default component.exports